export const FREIGHT_TABLE_STATUS = {
  ATIVA: 1,
  INATIVA: 2,
};

export const FREIGHT_TABLE_STATUS_LABEL = {
  [FREIGHT_TABLE_STATUS.ATIVA]: "Ativo",
  [FREIGHT_TABLE_STATUS.INATIVA]: "Inativo",
};

export const FREIGHT_TABLE_STATUS_FILTER = {
  ALL: "ALL",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

export const FREIGHT_TABLE_STATUS_FILTER_OPTIONS = [
  { value: FREIGHT_TABLE_STATUS_FILTER.ALL, label: "Todas" },
  { value: FREIGHT_TABLE_STATUS_FILTER.ACTIVE, label: "Ativa" },
  { value: FREIGHT_TABLE_STATUS_FILTER.INACTIVE, label: "Inativa" },
];

export const FREIGHT_TABLE_TABS = [
  {
    key: "todos",
    label: "Todos",
    tableStatus: FREIGHT_TABLE_STATUS_FILTER.ALL,
    isDraft: null,
  },
  {
    key: "ativas",
    label: "Ativas",
    tableStatus: FREIGHT_TABLE_STATUS_FILTER.ACTIVE,
    isDraft: null,
  },
  {
    key: "inativas",
    label: "Inativas",
    tableStatus: FREIGHT_TABLE_STATUS_FILTER.INACTIVE,
    isDraft: null,
  },
  {
    key: "rascunho",
    label: "Rascunho",
    tableStatus: FREIGHT_TABLE_STATUS_FILTER.ALL,
    isDraft: 1,
  },
];
